import { GameId } from "~/services/blastApi/shared/schemas/GameId";

interface GenerateTournamentLinkOptions {
  gameId: GameId;
  tournamentId: string;
}

export const generateTournamentLink = ({ gameId, tournamentId }: GenerateTournamentLinkOptions) => {
  let tournamentLink = "/";
  switch (gameId) {
    case "cs":
    case "dota":
    case "rl":
    case "pubg":
      tournamentLink = `/${gameId}/tournaments/${tournamentId}`;
      break;
    default:
      tournamentLink = "/";
      break;
  }

  return tournamentLink;
};
